import React from 'react';
import { useStyletron } from 'baseui';
import { Button, KIND as BUTTON_KIND, SHAPE as BUTTON_SHAPE, SIZE as BUTTON_SIZE } from 'baseui/button';
import { PLACEMENT as TOOLTIP_PLACEMENT, StatefulTooltip } from 'baseui/tooltip';
import { statefulTooltipSidePanelOverrides, TooltipContentLabel } from '../common/tooltip';
type PropsT = {
  icon: React.ReactNode;
  name: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  tooltipContent?: string;
  isActive?: boolean;
};
export function ActionButton({
  icon,
  name,
  onClick,
  tooltipContent,
  isActive
}: PropsT) {
  const [css, theme] = useStyletron();
  const buttonContent = <Button aria-label={name} kind={BUTTON_KIND.tertiary} shape={BUTTON_SHAPE.circle} size={BUTTON_SIZE.compact} overrides={{
    BaseButton: {
      style: {
        height: 'auto',
        width: 'auto',
        ...(isActive ? {
          backgroundColor: theme.colors.buttonTertiaryHover
        } : {})
      }
    }
  }} onClick={onClick}>
      {icon}
    </Button>;
  if (tooltipContent) {
    return <StatefulTooltip content={<TooltipContentLabel margin={0}>{tooltipContent}</TooltipContentLabel>} overrides={statefulTooltipSidePanelOverrides} showArrow placement={TOOLTIP_PLACEMENT.bottom}>
        <div className={css({
        display: 'flex'
      })}>{buttonContent}</div>
      </StatefulTooltip>;
  }
  return buttonContent;
}